import { useAuth } from "~/store/auth";
import { getDNSSuffix } from "./getDNSSuffix";
import type { IThreatMetric } from "~/types/threat-metric";
import { useSettings } from "~/store/settings";

interface SessionMetadata {
	sessionTrackingToken: string;
	uip: string;
}

const initialiseThreatmetrics = async (): Promise<SessionMetadata | undefined> => {
	const auth = useAuth();
	const settings = useSettings();
	try {
		const sessionMetadata = sessionStorage.getItem("sessionMetadata") || "{}";
		const parsedSessionMetadata = JSON.parse(sessionMetadata);
		if (!auth.hasThreatMetricsInitialised && settings.hasFeature("IsThreatMetricsEnabled") && !parsedSessionMetadata.sessionTrackingToken) {
			const session: SessionMetadata = await fetch("https://info.betwayafrica.com/api/v1/requestInfo", {
				method: "GET",
			})
				.then((res) => res.json())
				.then((res) => {
					auth.hasThreatMetricsInitialised = true;
					return res;
				})
				.then((res: IThreatMetric) => {
					const data = {
						...parsedSessionMetadata,
						sessionTrackingToken: res.hash,
						uip: res.IpAddress,
					};
					window.ProfileInit = () => {
						if (window?.thkdlhgd) window.thkdlhgd.prgssdw(getDNSSuffix("info.betway.co.tz"), "b5upb58k", res.hash, "100");

						sessionStorage.setItem("sessionMetadata", JSON.stringify(data));
					};
					if (!window?.thkdlhgd) {
						(function (d, src) {
							const script = d.createElement("script");
							script.type = "text/javascript";
							script.defer = true;
							script.async = true;
							script.onload = function () {
								if (!!window?.ProfileInit) window?.ProfileInit();
							};
							script.src = src;
							d.getElementsByTagName("body")[0].appendChild(script);
						})(document, "https://cdn.betwayafrica.com/BWA/lntk.js");
					} else {
						if (window?.ProfileInit) window?.ProfileInit();
					}
					return data;
				});
			return session;
		}
		return parsedSessionMetadata;
	} catch (e) {
		return undefined;
	}
};

export { initialiseThreatmetrics };
